/**
 * Subject line for the Invite / Message box in pool settings.
 *
 * One box sends both, so the subject has to follow the button. Six setup pages
 * each had their own copy of this and had drifted into three answers — "Message
 * from", "Update from", and NFL Pick 'Em sending no subject at all, which left
 * the server falling back to "You've been invited to join" on a message to
 * people already in the pool.
 *
 * Mirrors backend/core/invite_email.py — keep the two in step.
 */
export function inviteSubject(mode, poolName) {
  if (mode === "message") {
    // No pool name: the bar at the top of the email names the game and the
    // pool, and a subject opening with a pool name says nothing about who it
    // is from.
    return "You received a message from The Deep End";
  }
  return `You've been invited to join ${poolName || "a pool"} on The Deep End`;
}
